import styled, { css } from 'styled-components';
import { COLORS } from '../styles';

export const InputWrapper = styled.div<{ locked?: boolean; disabled?: boolean }>`
  outline: none;
  ${props => (props.locked || props.disabled ? 'cursor: not-allowed;' : '')}
`;

const lockedState = css`
  background-color: ${COLORS.neutral_100};
  box-shadow: inset 0px 0px 0px 1px ${COLORS.neutral_300} !important;
  color: ${COLORS.neutral_600} !important;
  pointer-events: none;
  outline: none;
  cursor: not-allowed;
`;
export const activeValidationMessageState = css`
  -webkit-box-shadow: inset 0px 0px 0px 2px ${COLORS.warning_400};
  -moz-box-shadow: inset 0px 0px 0px 2px ${COLORS.warning_400};
  box-shadow: inset 0px 0px 0px 2px ${COLORS.warning_400};
`;
const activeErrorMessageState = css`
  -webkit-box-shadow: inset 0px 0px 0px 2px ${COLORS.critical_400};
  -moz-box-shadow: inset 0px 0px 0px 2px ${COLORS.critical_400};
  box-shadow: inset 0px 0px 0px 2px ${COLORS.critical_400};
`;
const activeCorrectInput = css`
  -webkit-box-shadow: inset 0px 0px 0px 2px ${COLORS.correct_500};
  -moz-box-shadow: inset 0px 0px 0px 2px ${COLORS.correct_500};
  box-shadow: inset 0px 0px 0px 2px ${COLORS.correct_500};
`;
export const tabbedHereStyle = css`
  outline: none;
  box-shadow: 0px 4px 12px rgba(46, 127, 161, 0.25), 0px 0px 8px #2e7fa1 !important;
`;

const InputFieldStyling = styled.input<{
  locked?: boolean;
  activeValidationMessage?: boolean;
  activeErrorMessage?: boolean;
  correctInput?: boolean;
  active?: boolean;
  tabbedHere?: boolean;
}>`
  height: 56px;
  width: 100%;
  border-radius: 4px;
  border: 2px solid transparent;
  box-shadow: inset 0px 0px 0px 1px ${COLORS.neutral_300};
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 16px !important;

  padding-left: 7px;
  box-sizing: border-box;
  width: 100%;
  outline: none;
  border-radius: 4.5px;

  padding-top: 11px;

  font-size: 18px;
  color: ${COLORS.black} !important;

  ${props => (props.locked ? lockedState : '')}
  ${props => (props.activeValidationMessage ? activeValidationMessageState : '')}
  ${props => (props.activeErrorMessage ? activeErrorMessageState : '')}
  ${props => (props.correctInput ? activeCorrectInput : '')}
  ${props => (props.tabbedHere ? tabbedHereStyle : '')}

  &:disabled {
    border: 1px solid ${COLORS.neutral_100};
    pointer-events: none;
    box-shadow: none !important;
    outline: none;
    cursor: not-allowed;
    color: ${COLORS.neutral_300} !important;
  }
  &:focus {
    -webkit-box-shadow: inset 0px 0px 0px 2px ${COLORS.primary_800};
    -moz-box-shadow: inset 0px 0px 0px 2px ${COLORS.primary_800};
    box-shadow: inset 0px 0px 0px 2px ${COLORS.primary_800};
  }

  &.error {
    border-radius: 4px;
    border-style: solid;
    border-width: 2px;
    border-color: #e97116;
    padding: 0 15px !important;
  }

  &:not(.placeholder) {
    line-height: 40px;
  }

  &.error {
    margin-bottom: 0 !important;
  }

  &:hover {
    -webkit-box-shadow: inset 0px 0px 0px 2px ${COLORS.primary_700};
    -moz-box-shadow: inset 0px 0px 0px 2px ${COLORS.primary_700};
    box-shadow: inset 0px 0px 0px 2px ${COLORS.primary_700};
  }

  &.active {
    -webkit-box-shadow: inset 0px 0px 0px 2px ${COLORS.primary_800};
    -moz-box-shadow: inset 0px 0px 0px 2px ${COLORS.primary_800};
    box-shadow: inset 0px 0px 0px 2px ${COLORS.primary_800};
  }

  &::placeholder {
    font-family: 'Lato', sans-serif;
    font-style: italic;
    font-weight: normal;
    font-size: 18px;
    color: ${COLORS.neutral_600};
  }

  &.show-checkmark.valid {
    background-image: none;
  }

  &.show-checkmark.pending {
    background-image: none;
  }
`;

const ValidationStyling = css`
  &.error-msg {
    line-height: 14px;
    font-size: 13px;
    text-align: center;
    font-weight: 400;
    box-sizing: border-box;
  }

  &.error-msg {
    padding-top: 8px;
    padding-bottom: 0;
    color: #e76468;
    font-weight: 700;
    font-size: 13px;
    line-height: 15px;
  }
`;

export const RequiredStar = styled.span`
  color: ${COLORS.critical_500};
  font-size: 28px;
  line-height: 12px;
  float: right;
  font-weight: 700;
  position: relative;
  top: 10px;
`;
export const Warning = styled.div`
  font-size: 14px;
  line-height: 140%;

  & * {
    vertical-align: middle;
    display: inline-block;
  }

  svg {
    margin-right: 5px;
  }
`;
export const WarningMessage = styled(Warning)`
  color: ${COLORS.warning_500};
`;
export const ErrorMessage = styled(Warning)`
  color: ${COLORS.critical_500};
`;
export const AutofilledMessage = styled(Warning)`
  color: ${COLORS.neutral_600};
`;

export { ValidationStyling, InputFieldStyling };
